import { render, staticRenderFns } from "./AddTraining.vue?vue&type=template&id=cefc0b74&scoped=true&"
import script from "./AddTraining.vue?vue&type=script&lang=js&"
export * from "./AddTraining.vue?vue&type=script&lang=js&"
import style0 from "./AddTraining.vue?vue&type=style&index=0&id=cefc0b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefc0b74",
  null
  
)

component.options.__file = "AddTraining.vue"
export default component.exports